import React from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col } from 'react-bootstrap';


function MtechEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
            <Programmesleft activeIndex={5}/>
          </Col>

          <Col md={8} className='c-right'>
           
           
            <div className="c-heading">
              <h3>Ph.D</h3>
              </div>
            <p>
              IT Tirupati offers Ph.D program in the following Departments: 
            </p>


            <ul className='myulcustarrow'>
              <li> Chemical Engineering</li>
              <li> Civil & Environmental Engineering</li>
              <li> Computer Science & Engineering</li>
              <li> Electrical Engineering</li>
              <li> Mechanical Engineering</li>
              <li> Chemistry</li>
              <li> Physics</li>
              <li> Mathematics and Statistics</li>
              <li> Humanities and Social Sciences</li>
            </ul>
     
            <p>
              For more information, please visit department and faculty research profiles.
            </p>
            <p>
              For admissions related information  
          
              <Link to="/ph-d-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                            click here
                </Link>
         
            </p>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MtechEle;
